module.exports = __webpack_public_path__ + "gb.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/css/fonts/flag-icon-css/flags/4x3/gb.svg
// module id = 555
// module chunks = 0